import React from 'react';
import {
    BaseToolbarDimension, BaseToolbarMarginOrPadding, BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson,
} from 'wsc-react-custom-form';
export const Settings = () => {
    return (
        <React.Fragment>
            <BaseToolbarInputGroup>
                {/*  widthRation可选：不填的话，label宽度占30%；填写的值在1-99之间*/}
                <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50} />
                <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50} />
                <BaseInput propKey='type' label='Type' tooltipTitle='图片类型说明' widthRation={50} />
                <BaseToolbarSelect
                    propKey='required'
                    label='必填项'
                    tooltipTitle='是否为必填项'
                    options={[
                        { value: 'true', label: '是' },
                        { value: 'false', label: '否' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarJson propKey="rules" label='校验规则' tooltipTitle='表单组件的校验规则' widthRation={50} />
                <BaseToolbarSelect
                    propKey='disabled'
                    label='禁用编辑'
                    tooltipTitle='是否禁用表单组件'
                    options={[
                        { value: 'true', label: '禁用' },
                        { value: 'false', label: '不禁用' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='visible'
                    label='可见'
                    tooltipTitle='是否显示表单组件'
                    options={[
                        { value: 'true', label: '是' },
                        { value: 'false', label: '否' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='isNewLine'
                    label='标签位置'
                    tooltipTitle='组件标签和组件位置关系'
                    options={[
                        { value: 'true', label: '垂直' },
                        { value: 'false', label: '水平' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='border'
                    label='底部边框'
                    tooltipTitle='是否显示组件边框'
                    options={[
                        { value: 'true', label: '是' },
                        { value: 'false', label: '否' }
                    ]}
                    widthRation={50}
                />

                <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50} />
                <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
                <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
                <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />
            </BaseToolbarInputGroup>

            {/* 把一组input统一包起来， 可以用caption属性来置顶一个统一的标题 */}
            <BaseToolbarInputGroup>
                <BaseInput propKey='uploadApi' label='UploadApi' tooltipTitle='图片上传api地址' />
                <BaseInput propKey='count' label='图片张数' tooltipTitle='图片张数' />
                <BaseInput propKey='length' label='单行数量' tooltipTitle='单行数量' />
                <BaseToolbarSelect
                    propKey='multiple'
                    label='多选'
                    tooltipTitle='可多选'
                    options={[
                        { value: 'true', label: '多选' },
                        { value: 'false', label: '单选' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='mode'
                    label='类型'
                    tooltipTitle='类型'
                    options={[
                        { value: 'scaleToFill', label: 'scaleToFill' },
                        { value: 'aspectFit', label: 'aspectFit' },
                        { value: 'aspectFill', label: 'aspectFill' },
                        { value: 'widthFix', label: 'widthFix' },
                        { value: 'top', label: 'top' },
                        { value: 'bottom', label: 'bottom' },
                        { value: 'center', label: 'center' },
                        { value: 'left', label: 'left' },
                        { value: 'right', label: 'right' },
                        { value: 'top left', label: 'top left' },
                        { value: 'top right', label: 'top right' },
                        { value: 'bottom left', label: 'bottom left' },
                        { value: 'bottom right', label: 'bottom right' },
                    ]}
                    widthRation={50}
                />
            </BaseToolbarInputGroup>
        </React.Fragment>
    );
};
